/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { ToastProvider } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import metadata from './LifeAgentsPage.metadata.json5';
import styles from './LifeAgentsPage.module.scss';
import messages from './LifeAgentsPage.messages';
import UndewritingComponent from '../../components/LifeAgents/Underwriting/UnderwritingComponent';
import AdditionalInformationComponent from '../../components/LifeAgents/AdditionalInformation/AdditionalInformationComponent';
import RiskInformationComponent from '../../components/LifeAgents/RiskInformation/RiskInformationComponent';

function LifeAgentsPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const translator = useTranslator();
    const { lineName } = PremierConstants;
    const {
        onValidate,
        initialValidation
    } = useValidation('LifeAgentsPage');
    

    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {
            if (!_.isUndefined(submissionVM.lobData.proLine.coverables.lifeAgentsCoverable.value.additionalInfo.isTheAppSResForMai10)
                && submissionVM.lobData.proLine.coverables.lifeAgentsCoverable.value.additionalInfo.isTheAppSResForMai10
                && submissionVM.lobData.proLine.coverables.lifeAgentsCoverable.value.additionalInfo.formerEntityTable.length === 0) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.formerEntityErrorMessage),
                    autoClose: true
                });

                return false;
            }

            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'ArchitectEngineerPage', submissionVM);

            return submissionVM;

        },
        [submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.proLine.coverables.lifeAgentsCoverable.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            
            await updateSubmission(lobLineName, 'LifeAgentsPage', subVMCopy);
                            
            return submissionVM;
        },
        [submissionVM]
      );

    const overrideProps = {
        undewritingComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.lifeAgentsCoverable.underwriting"
        },
        additionalInfoComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.lifeAgentsCoverable.additionalInfo"
        },
        riskInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.lifeAgentsCoverable.riskInformation"
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            undewritingComponent: UndewritingComponent,
            additionalInfoComponent: AdditionalInformationComponent,
            riskInformationComponent: RiskInformationComponent,
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => (!_.isUndefined(submissionVM.lobData) &&
        !submissionVM.lobData.proLine.coverables.lifeAgentsCoverable.aspects.subtreeValid) || 
        (![undefined, '', '0', 0, null].includes(_.get(submissionVM, 'lobData.proLine.coverables.lifeAgentsCoverable.value.additionalInfo.investmentTable[3].groCom2.amount')) &&
        _.isEmpty(submissionVM.lobData.proLine.coverables.lifeAgentsCoverable.value.additionalInfo.investmentTable[3].des3))
        

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LifeAgentsPage.propTypes = wizardProps;
export default withRouter(LifeAgentsPage);
